import * as svg from "../../../assets/pointer-up-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PointerUpIcon = iconBuilder(svg, "PointerUpIcon", "0 0 24 24");
